import * as React from 'react';
import {colorBackground, colorBrand, colorSlate} from '../theme/color';
import {classes, style} from 'typestyle';
import {transitionQuickEase} from '../theme/transition';
import {betweenJustified, center, horizontal} from 'csstips';
import {important, px} from 'csx';
import {SVGIcon} from './svg-icon';

const PrismicDOM = require('prismic-dom');

export interface PageFAQSectionItem {
  question: string;
  answer: any;
  slug: any;
}

export interface PageFAQSectionProps {
  section: {
    primary: {
      title: string;
    },
    items: Array<PageFAQSectionItem>
  };
}

export interface PageFAQSectionState {
  show: {[index: number]: boolean};
}

export class PageFAQSection extends React.Component<PageFAQSectionProps, PageFAQSectionState> {
  render() {
    const { section } = this.props;

    return (
      <div className={PageFAQSection.styles.container}>
        <h2>{section.primary.title}</h2>
        <ul>{section.items.map(this.renderItem)}</ul>
      </div>
    )
  }

  renderItem = ({question, answer, slug}: PageFAQSectionItem, index: number) => {
    if (!question || !answer)
      return null;

    const className = classes(
      PageFAQSection.styles.item,
      this.state.show[index]
        ? PageFAQSection.styles.show
        : PageFAQSection.styles.hide
    );

    return (
      <li id={slug + index} className={className} key={slug + index}>
        <div onClick={this.toggle.bind(this, index)}>
          <span>{question}</span>
          <SVGIcon.ArrowRight size={10} />
        </div>
        <div dangerouslySetInnerHTML={{ __html: PrismicDOM.RichText.asHtml(answer) }} />
      </li>
    )
  };

  constructor(props) {
    super(props);
    this.state = { show: {} };
  }

  toggle = (index: number) => this.setState(({show}) => ({
    show: {
      ...show,
      [index]: !show[index]
    }
  }));

  static styles = {
    container: style({
      margin: '0 0 60px 0',
      $nest: {
        '& ul': {
          margin: 0,
          padding: 0,
          listStyle: 'none inside none'
        },
        '& ul li': {
          margin: '-1px 0 0 0'
        },
      }
    }),
    item: style({
      $nest: {
        '& > div:first-child': {
          ...horizontal,
          ...betweenJustified,
          ...center,
          cursor: 'pointer',
          borderTop: `1px solid ${colorBackground.toString()}`,
          borderBottom: `1px solid ${colorBackground.toString()}`,
          margin: 0,
          padding: '15px 0',
          fontSize: px(20),
          fontWeight: 400,
          transition: `color ${transitionQuickEase}`
        },
        '& > div:first-child:hover': {
          color: colorBrand.toString()
        },
        '& > div:first-child svg': {
          transition: `transform 0.125s linear`
        },
        '& > div:first-child svg path': {
          fill: colorSlate.toString(),
          transition: `color ${transitionQuickEase}`
        },
        '& > div:first-child:hover svg path': {
          fill: colorBrand.toString()
        },
        '&> div:last-child': {
          display: 'initial'
        },
      }
    }),
    show: style({
      $nest: {
        '&> div:last-child': {
          display: important('block')
        },
        '&> div:first-child > svg': {
          transform: 'rotate(90deg)'
        }
      }
    }),
    hide: style({
      $nest: {
        '&> div:last-child': {
          display: important('none')
        },
        '&> div:first-child > svg': {
          transform: 'rotate(0)'
        }
      }
    })
  }
}